import { render, staticRenderFns } from "./StatsModal.vue?vue&type=template&id=318e28f6&"
import script from "./StatsModal.vue?vue&type=script&lang=js&"
export * from "./StatsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports